import {Component, Inject, Input, OnInit} from '@angular/core';
import {RequestConfirmationHelperObject} from '../../../model/RequestConfirmationHelperObject';
import {Router} from '@angular/router';
import {RequestMetadata} from '../../../generate/RequestMetadata';

@Component({
  selector: 'submit-confirmation',
  templateUrl: './submit-confirmation.component.html',
  styleUrls: ['./submit-confirmation.component.scss']
})
export class SubmitConfirmationComponent implements OnInit {

  @Input()
  requestConfirmation: RequestConfirmationHelperObject;

  @Input()
  deleteRequest: boolean;

  @Input()
  domainName: string;

  @Input()
  newDelegation: boolean;

  @Input()
  showTicketNumber: boolean;

  @Input()
  requestMetadata: RequestMetadata;


  @Input()
  updateChangeRequest: boolean;
  isStaffUI = false;

  constructor(private router: Router,
              @Inject('env') private environment) {
  }

  ngOnInit() {
    this.isStaffUI = this.environment.config.interfaceType === 'STAFF';
  }

  goToHome() {
    this.router.navigateByUrl('/user/home');
  }

}
